export const runtimeNames = {
  state: {
    working: 'working',
    modals: 'modals',
    mainbranch: 'mainbranch'
  },
  mutations: {
    SET_WORKING: 'SET_WORKING',
    ADD_MODAL: 'ADD_MODAL',
    REM_MODAL: 'REM_MODAL'
  },
  actions: {},
  getters: {
    working: 'working',
    modals: 'modals',
    modalsOpen: 'modalsOpen',
    mainbranch: 'mainbranch'
  }
}

export default runtimeNames
